/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderDTO,
  OrderDTOOptional,
  OrderDTOMetaI,
  OrderDTOTrackedI,
} from "./order-dto";
import { OrderDTOTracked, OrderDTOMeta } from "./order-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentDTO,
  OrderPaymentDTOOptional,
  OrderPaymentDTOMetaI,
  OrderPaymentDTOTrackedI,
} from "./order-payment-dto";
import {
  OrderPaymentDTOTracked,
  OrderPaymentDTOMeta,
} from "./order-payment-dto";

/**
 *
 * @export
 * @interface CreateOrderPaymentResponseDTO
 */
export interface CreateOrderPaymentResponseDTOOptional {
  /**
   *
   * @type {OrderPaymentDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  payment?: OrderPaymentDTOOptional;
  /**
   *
   * @type {OrderDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  orderUpdated?: OrderDTOOptional;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentResponseDTO
   */
  isFree?: boolean;
}

export interface CreateOrderPaymentResponseDTO extends CreateOrderPaymentResponseDTOOptional {
  /**
   *
   * @type {OrderPaymentDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  payment?: OrderPaymentDTO;
  /**
   *
   * @type {OrderDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  orderUpdated?: OrderDTO;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentResponseDTO
   */
  isFree?: boolean;
}

export interface CreateOrderPaymentResponseDTOTrackedI {
  /**
   *
   * @type {OrderPaymentDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  payment?: OrderPaymentDTOTrackedI;
  paymentIsSet: boolean;
  /**
   *
   * @type {OrderDTO}
   * @memberof CreateOrderPaymentResponseDTO
   */
  orderUpdated?: OrderDTOTrackedI;
  orderUpdatedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreateOrderPaymentResponseDTO
   */
  isFree?: boolean;
  isFreeIsSet: boolean;
}

transformDatesMap.set(
  "CreateOrderPaymentResponseDTO",
  function (model: CreateOrderPaymentResponseDTO) {
    const transformDatespayment = transformDatesMap.get("OrderPaymentDTO");
    if (transformDatespayment && model.payment) {
      transformDatespayment(model.payment);
    }
    const transformDatesorderUpdated = transformDatesMap.get("OrderDTO");
    if (transformDatesorderUpdated && model.orderUpdated) {
      transformDatesorderUpdated(model.orderUpdated);
    }
  },
);

export type CreateOrderPaymentResponseDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  payment: PropertyMeta<OrderPaymentDTOMetaI>;
  //isDate: false
  //isDatetime: false
  orderUpdated: PropertyMeta<OrderDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isFree: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var CreateOrderPaymentResponseDTOMeta: CreateOrderPaymentResponseDTOMetaI =
  {} as CreateOrderPaymentResponseDTOMetaI;
CreateOrderPaymentResponseDTOMeta = typeMeta("CreateOrderPaymentResponseDTO", {
  payment: propertyMeta("payment", false, false, false, OrderPaymentDTOMeta),
  orderUpdated: propertyMeta("orderUpdated", false, false, false, OrderDTOMeta),
  isFree: propertyMeta("isFree", false, false, false, MetaTypesBase.boolean),
});

const metaI = CreateOrderPaymentResponseDTOMeta;

registerMeta(() => {});

export class CreateOrderPaymentResponseDTOTracked implements CreateOrderPaymentResponseDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  payment__I?: OrderPaymentDTOTracked = undefined;
  paymentIsSet: boolean = false;
  set payment(v: undefined | OrderPaymentDTOTracked) {
    if (v !== undefined) {
      this.payment__I = v;
      this.paymentIsSet = true;
    } else {
      this.payment__I = v || undefined;
      this.paymentIsSet = false;
    }
    this.changeTracker = true;
  }
  get payment() {
    return this.payment__I;
  }
  orderUpdated__I?: OrderDTOTracked = undefined;
  orderUpdatedIsSet: boolean = false;
  set orderUpdated(v: undefined | OrderDTOTracked) {
    if (v !== undefined) {
      this.orderUpdated__I = v;
      this.orderUpdatedIsSet = true;
    } else {
      this.orderUpdated__I = v || undefined;
      this.orderUpdatedIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderUpdated() {
    return this.orderUpdated__I;
  }
  isFree__I?: boolean = undefined;
  isFreeIsSet: boolean = false;
  set isFree(v: undefined | boolean) {
    if (v !== undefined) {
      this.isFree__I = v;
      this.isFreeIsSet = true;
    } else {
      this.isFree__I = v || undefined;
      this.isFreeIsSet = false;
    }
    this.changeTracker = true;
  }
  get isFree() {
    return this.isFree__I;
  }
  constructor(
    config?: CreateOrderPaymentResponseDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.payment?.setIds();

    this.orderUpdated?.setIds();
  }
  assignFrom(
    config: CreateOrderPaymentResponseDTOOptional,
    options?: AssignOptions,
  ): CreateOrderPaymentResponseDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.payment && this.paymentApplyFilter(optionsRequired.filter)) {
      this.payment = new OrderPaymentDTOTracked(config.payment, options);
      if (optionsRequired.unassign) this.paymentIsSet = false;
      else this.paymentIsSet = true;
    }
    if (
      config.orderUpdated &&
      this.orderUpdatedApplyFilter(optionsRequired.filter)
    ) {
      this.orderUpdated = new OrderDTOTracked(config.orderUpdated, options);
      if (optionsRequired.unassign) this.orderUpdatedIsSet = false;
      else this.orderUpdatedIsSet = true;
    }
    if (config.isFree && this.isFreeApplyFilter(optionsRequired.filter)) {
      this.isFree = config.isFree;
      if (optionsRequired.unassign) this.isFreeIsSet = false;
      else this.isFreeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CreateOrderPaymentResponseDTOTrackedI {
    const cloned = {} as CreateOrderPaymentResponseDTOTrackedI;
    if (
      this.paymentIsSetDeep() &&
      this.paymentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentIsSet = true;
      cloned.payment = this.payment?.removeUnset(filter);
    } else {
      //cloned.paymentIsSet = false
    }
    if (
      this.orderUpdatedIsSetDeep() &&
      this.orderUpdatedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderUpdatedIsSet = true;
      cloned.orderUpdated = this.orderUpdated?.removeUnset(filter);
    } else {
      //cloned.orderUpdatedIsSet = false
    }
    if (
      this.isFreeIsSetDeep() &&
      this.isFreeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isFreeIsSet = true;
      cloned.isFree = this.isFree;
    } else {
      //cloned.isFreeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CreateOrderPaymentResponseDTOTrackedI {
    if (!this.paymentApplyFilter(filter)) this.paymentIsSet = false;
    this.payment?.unassignAll(filter);

    if (!this.orderUpdatedApplyFilter(filter)) this.orderUpdatedIsSet = false;
    this.orderUpdated?.unassignAll(filter);

    if (!this.isFreeApplyFilter(filter)) this.isFreeIsSet = false;

    return this;
  }
  paymentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentResponseDTOMeta.payment,
      CreateOrderPaymentResponseDTOMeta,
      this.payment,
      this,
    );
  }
  paymentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentIsSet && this.paymentApplyFilter(filter)) return true;
    return this.payment?.anySet(filter) == true;

    return false;
  }
  orderUpdatedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentResponseDTOMeta.orderUpdated,
      CreateOrderPaymentResponseDTOMeta,
      this.orderUpdated,
      this,
    );
  }
  orderUpdatedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderUpdatedIsSet && this.orderUpdatedApplyFilter(filter))
      return true;
    return this.orderUpdated?.anySet(filter) == true;

    return false;
  }
  isFreeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateOrderPaymentResponseDTOMeta.isFree,
      CreateOrderPaymentResponseDTOMeta,
      this.isFree,
      this,
    );
  }
  isFreeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isFreeIsSet && this.isFreeApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentIsSetDeep(filter)) return true;
    if (this.orderUpdatedIsSetDeep(filter)) return true;
    if (this.isFreeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
